import util from '@bmp-vue/core/api/util'
const controller = 'BMPCred'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
